import { HistoryOutlined } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import {
  AdditionalFormFieldProps,
  BaseFormFieldDefinition,
} from "@pimo/pimo-components/src/lib/pimo-components/pimo-form/form-field";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { formatDateTime } from "../../utils/format-date";

export const DC_RELEVANCE_IMPORT_INFO_FIELD_TYPE =
  "dcRelevanceImportInfo" as const;

export type DcRelevanceImportInfoFieldDefinition = BaseFormFieldDefinition<
  typeof DC_RELEVANCE_IMPORT_INFO_FIELD_TYPE
> & {
  modifiedAt: string;
  language?: string;
};

export const DcRelevanceImportInfoField = ({
  modifiedAt,
  language = "en",
}: DcRelevanceImportInfoFieldDefinition & AdditionalFormFieldProps) => {
  const date = formatDateTime(modifiedAt, language);
  const key = "dcRelevanceModifiedImport.info";
  const message = getLocalizedMessage(language, key, { date });

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <HistoryOutlined sx={{ fontSize: 18, color: grey[600] }} />
      <Typography sx={{ fontSize: 13, color: grey[700] }}>
        {!message || message === key
          ? `DC Relevance modified by the ADOIT import on ${date}`
          : message}
      </Typography>
    </Box>
  );
};
